import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";
import { BRAND_PHOTOS, CATEGORIES, CATEGORY_PHOTO, PHONE } from "@/lib/constants";

const DivisionCard = ({ c, i }) => (
  <Link to={`/services/${c.key}`} data-testid={`service-selector-${c.key}-card`}
    style={{ animationDelay: `${0.15 + i * 0.1}s` }}
    className="am-rise group relative overflow-hidden rounded-xl border border-white/12 bg-[#0C132B]/70 backdrop-blur-md hover:border-[#F86900] transition-colors">
    <img src={CATEGORY_PHOTO[c.key]} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30 group-hover:opacity-45 group-hover:scale-105 transition-[opacity,transform] duration-500" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#070B19] via-[#070B19]/70 to-transparent" />
    <div className="relative p-4 lg:p-5 flex flex-col h-full min-h-[120px] lg:min-h-[150px] justify-end">
      <span className="font-display text-[10px] uppercase tracking-[0.2em] font-bold text-[#F86900]">{c.tag}</span>
      <h3 className="mt-1 font-display font-bold text-lg text-white flex items-center gap-2">
        {c.title} <ArrowRight className="h-4 w-4 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-[opacity,transform]" />
      </h3>
      <p className="mt-1 text-xs text-white/65 leading-snug">{c.desc}</p>
    </div>
  </Link>
);

export default function Home() {
  return (
    <div className="relative min-h-[100svh] lg:h-[100svh] lg:overflow-hidden bg-[#020165] am-grain" data-testid="home-page">
      <img src={BRAND_PHOTOS[1]} alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0" style={{ background: "linear-gradient(100deg, rgba(2,1,101,0.95) 0%, rgba(2,1,101,0.86) 45%, rgba(7,11,25,0.75) 100%)" }} />
      <div className="relative z-10 flex flex-col justify-between min-h-[100svh] lg:h-full w-full px-4 sm:px-6 lg:px-12 py-4 gap-4">
        <SiteHeader />
        <section className="flex-1 flex flex-col justify-center max-w-6xl mx-auto w-full py-4">
          <p className="am-rise font-display text-[11px] uppercase tracking-[0.2em] font-bold text-[#F86900]">Harare, Zimbabwe • 3 Hunter Rd, New Ardbennie</p>
          <h1 data-testid="hero-heading" className="am-rise mt-3 font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-white max-w-3xl" style={{ animationDelay: "0.05s" }}>
            Restore. Refine. <span className="text-[#F86900]">Personalise.</span>
          </h1>
          <p className="am-rise mt-4 text-white/75 text-base md:text-lg max-w-2xl leading-relaxed" style={{ animationDelay: "0.1s" }}>
            Repairs, detailing and customisation from one Harare workshop — with written quotes, booked bays and live job tracking.
          </p>
          <div className="am-rise mt-6 flex flex-wrap gap-3" style={{ animationDelay: "0.12s" }}>
            <Link to="/quote" data-testid="hero-get-quote-cta" className="px-7 py-3 rounded-full bg-[#F86900] text-[#0D141A] font-bold hover:bg-[#ff7d1f] transition-colors">Get a Quote</Link>
            <Link to="/book" data-testid="hero-book-service-cta" className="px-7 py-3 rounded-full border border-white/30 text-white font-semibold hover:bg-white/10 transition-colors">Book a Service</Link>
          </div>
          <p className="mt-7 mb-3 font-display text-[11px] uppercase tracking-[0.2em] font-bold text-white/50">Select workshop division</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            {CATEGORIES.map((c, i) => <DivisionCard key={c.key} c={c} i={i} />)}
          </div>
          <div className="mt-4 flex flex-col md:flex-row md:items-center justify-between gap-3">
            <Link to="/track" data-testid="hero-discreet-track-job-link" className="text-sm text-white/70 hover:text-[#F86900] transition-colors">
              Have an ongoing job? <span className="font-semibold underline underline-offset-4">Track My Job →</span>
            </Link>
            <div data-testid="hero-roadside-call-strip" className="flex items-center gap-3 rounded-full border border-[#F86900]/50 bg-[#F86900]/10 pl-4 pr-1 py-1">
              <span className="text-xs text-white/80">Breakdown or need a tow?</span>
              <a href={`tel:${PHONE}`} data-testid="hero-roadside-phone-link" className="flex items-center gap-1.5 rounded-full bg-[#F86900] text-[#0D141A] text-sm font-bold px-4 py-1.5">
                <Phone className="h-3.5 w-3.5" /> {PHONE}
              </a>
              <Link to="/roadside" data-testid="hero-roadside-help-link" className="text-xs font-semibold text-[#F86900] pr-3 hidden sm:inline">Roadside Help</Link>
            </div>
          </div>
        </section>
        <SiteFooter compact />
      </div>
    </div>
  );
}
